import { useEffect, useState } from 'react';
import {
  STUDENT_ACCESS_DISABLED_EVENT,
  STUDENT_ACCESS_DISABLED_MESSAGE,
  isStudentAccessDisabled,
} from '../../../../services/AxiosInstance';

/**
 * A red notice across the top of the student dashboard, shown once
 * lms-api has refused the student because every batch they were enrolled
 * in has ended. Inline rather than a popup: the student can still read
 * what the page shows, and the reason stays in view.
 */
const StudentAccessBanner = () => {
  const [disabled, setDisabled] = useState(isStudentAccessDisabled);

  useEffect(() => {
    // The flag may have been raised between the first render and now.
    if (isStudentAccessDisabled()) setDisabled(true);
    const onDisabled = () => setDisabled(true);
    window.addEventListener(STUDENT_ACCESS_DISABLED_EVENT, onDisabled);
    return () => window.removeEventListener(STUDENT_ACCESS_DISABLED_EVENT, onDisabled);
  }, []);

  if (!disabled) return null;

  return (
    <div className="sd-access-banner" role="alert">
      {STUDENT_ACCESS_DISABLED_MESSAGE}
    </div>
  );
};

export default StudentAccessBanner;
